// extracted by mini-css-extract-plugin
module.exports = {"connect-wallet":"ConnectWalletButton_connect-wallet__1whUe","disconnect":"ConnectWalletButton_disconnect__2VSeq"};